'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _chart_utility = require('../../../../packages/common-utilities/src/chart_utility.js');

var _chart_utility2 = _interopRequireDefault(_chart_utility);

var _date_formatter = require('../../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chart_utility3 = require('../../../../packages/common-utilities/src/chart_utility');

var _ramda = require('ramda');

var _d = require('../../../../src/main/resources/static/vendor/scripts/firevis-1.0.1/dependencies/d3-4.2.6/d3.min');

var d3 = _interopRequireWildcard(_d);

var _collection_utility = require('common-utilities/src/collection_utility');

var _string_utility = require('common-utilities/src/string_utility');

var _string_utility2 = _interopRequireDefault(_string_utility);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DailyPerformanceChart = function (_React$Component) {
  _inherits(DailyPerformanceChart, _React$Component);

  function DailyPerformanceChart(props) {
    _classCallCheck(this, DailyPerformanceChart);

    return _possibleConstructorReturn(this, (DailyPerformanceChart.__proto__ || Object.getPrototypeOf(DailyPerformanceChart)).call(this, props));
  }

  /* eslint-disable*/


  _createClass(DailyPerformanceChart, [{
    key: 'createPerformanceChart',
    value: function createPerformanceChart(printWidth) {
      return (0, _chart_utility.generateChart)((0, _chart_utility3.generateChartId)("DailyPerformanceChart", printWidth && typeof printWidth === "number"), "linechart", this.props.plotPoints, this.getChartConfiguration(printWidth));
    }
  }, {
    key: 'getChartConfiguration',
    value: function getChartConfiguration(printWidth) {
      var _this2 = this;

      var _props = this.props,
          yTicks = _props.yTicks,
          xTicks = _props.xTicks,
          dateOption = _props.dateOption,
          breakpoint = _props.breakpoint;

      var formattedTicks = _chart_utility2.default.createTicksFormattedInD3DateFormat(xTicks);
      var firstXTick = formattedTicks[0];
      var marginLeft = breakpoint < 4 ? 77 : 85;
      var marginRight = breakpoint < 4 ? 0 : 20;
      var fontSize = breakpoint < 4 ? this.props.country === 'au' ? "13px" : "12px" : "15px";
      var colors = ["#70C4FF"];
      var values = ["cumulativeNoLoadPercentageInc", "cumulativeNoLoadPercentage"];
      var formattedDates = _collection_utility.CollectionUtility.reduce(this.props.plotPoints, function (map, value) {
        var date = _date_formatter2.default.getLocalFormattedDateForInjectIntl(value.date, _this2.props.intl);
        map[value.date] = _extends({}, value, { formattedDate: date });
        return map;
      }, {});
      var startDate = d3.timeParse("%Y-%m-%d")(this.props.plotPoints[0].date);
      var endDate = d3.timeParse("%Y-%m-%d")(this.props.plotPoints[this.props.plotPoints.length - 1].date);

      var spec = (0, _ramda.mergeDeepLeft)({
        "selector": "#DailyPerformanceChart",
        "keys": ["date"],
        "values": values,
        "container": {
          "marginBottom": 50,
          "marginLeft": marginLeft,
          "marginRight": marginRight,
          "rangePaddingRight": 0
        },
        "scaled": true,
        "type": "line",
        "style": {
          "fill": colors
        },
        "colors": colors,
        "axis": {
          "x": {
            "show": true,
            "tick": {
              "padding": 5,
              "values": formattedTicks
            },
            "label": {
              "show": true,
              "text": function text(d) {
                if (d === firstXTick && dateOption === 0) {
                  return "";
                } else {
                  return _date_formatter2.default.getDateInMonthYearFormat(d);
                }
              },
              "style": {
                "font-family": "NBInternational",
                "font-size": "12px"
              }
            },
            "domain": [startDate, endDate]
          },
          "y": {
            "domain": [yTicks[0], yTicks[yTicks.length - 1]],
            "label": {
              "show": true,
              "style": {
                "font-family": "NBInternational",
                "font-size": "12px"
              },
              "text": function text(d) {
                return d + "%";
              }
            },
            "tick": {
              "padding": 5,
              "grid": true,
              "style": {
                "stroke": "lightgrey"
              },
              "values": yTicks
            },
            "line": {
              "show": false
            }
          }
        },
        "hoverLine": {
          "tooltip": {
            "style": {
              "font-size": fontSize
            },
            "text": function text(data) {
              var formattedItem = formattedDates[data.date];
              var formatteddateDisplay = formattedItem.formattedDate;
              var cumulativeNoLoadPercentage = (0, _ramda.isNil)(data.cumulativeNoLoadPercentage) ? '-' : data.cumulativeNoLoadPercentage.toFixed(2) + '%';
              var cumulativeNoLoadPercentageInc = (0, _ramda.isNil)(data.cumulativeNoLoadPercentageInc) ? '-' : data.cumulativeNoLoadPercentageInc.toFixed(2) + '%';
              var text = "<div style= 'text-align:left'>";
              text += "<div class='caption' style='font-weight:100'>" + formatteddateDisplay + "</div>";
              text += "<div class='font-regular'>" + _string_utility2.default.getLocalizedString(_this2.props.intl, "Daily Return: ", "pdp-daily-performance-daily-return") + " " + cumulativeNoLoadPercentage + "</div>";
              text += "<div class='font-regular'>" + _string_utility2.default.getLocalizedString(_this2.props.intl, "Approx cumulative return: ", "pdp-daily-performance-approx-cumulative-return") + " " + cumulativeNoLoadPercentageInc + "</div>";
              d3.select(".firevis-tooltip").style("display", "block");
              text += "</div>";
              return text;
            }
          }
        }
      }, _chart_utility3.COMMON_CHART_CONFIG);

      if (printWidth && typeof printWidth === "number") {
        spec.container.width = (0, _chart_utility3.getChartPrintWidth)();
        spec.container.height = (0, _chart_utility3.getChartPrintHeight)();
      }
      return spec;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.plotPoints.length === 0) {
        return null;
      }
      var performanceChart = this.createPerformanceChart();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'print-hide' },
          _react2.default.createElement(performanceChart)
        ),
        _react2.default.createElement(
          'div',
          { className: 'print-display', style: { display: "none" } },
          _react2.default.createElement(this.createPerformanceChart(800))
        )
      );
    }
  }]);

  return DailyPerformanceChart;
}(_react2.default.Component);

/* eslint-enable*/


exports.default = DailyPerformanceChart;